import React from 'react';
import './styles.scss';
type Props = {
  title: string;
  theme: string;
  onClick: any;
  disabled?: boolean;
  style?: React.CSSProperties;
};
const ThemedButton = (props: Props) => {
  const title = props.title;
  return (
    <div
      style={props.style}
      className={`editor-button-theme-${props.theme} hoverable btn ${
        props.disabled === false ? 'disabled' : ''
      }`}
      onClick={props.onClick}>
      {title}
    </div>
  );
};

export default ThemedButton;
